<template>
  <div ref="createChallengeFlow" class="create-challenge-flow">
    <choose-amount v-if="componentName === componentNames.chooseAmount" @nextStep="goToNextComponent"/>
    <invite-participants v-else-if="componentName === componentNames.inviteParticipants"/>
  </div>
</template>

<script>
import ChooseAmount
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ChooseAmount';
import InviteParticipants
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/InviteParticipants';
import { mapState, mapActions } from 'vuex';
import Segment from '@/Segment';
import { EATING_OUT_CHALLENGE_PROTOTYPE_V1 } from './constants';

const componentNames = {
  chooseAmount: 'choose-amount',
  inviteParticipants: 'invite-participants',
};

export default {
  name: 'CreateChallengeWizard',
  components: {
    ChooseAmount,
    InviteParticipants,
  },
  data() {
    return {
      componentName: null,
    };
  },
  async created() {
    Segment.trackUserGot('EatingOutChallengeCustomerEnteredChallengeCreation', { shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1 });
    await this.initChallengeCreation();
    this.goToNextComponent();
  },
  computed: {
    ...mapState('accountabilityChallenge', ['ownerParticipantId', 'activeChallenge']),
    componentNames() {
      return componentNames;
    },
  },
  methods: {
    ...mapActions('accountabilityChallenge', ['initChallengeCreation', 'goToChallengeDashboard']),
    goToNextComponent() {
      if (!this.ownerParticipantId) {
        this.componentName = this.componentNames.chooseAmount;
        return;
      }
      if (!this.activeChallenge || this.activeChallenge.participants.length === 1) {
        this.componentName = this.componentNames.inviteParticipants;
        return;
      }
      this.goToChallengeDashboard();
    },
  },
};
</script>

<style scoped>

</style>
